export default __webpack_public_path__ + "static/edge-with-couch-c165fc7c64fc3d48461eecc4fe30476b.jpg";